<template>
  <div>
    <Header />
    <!-- #region 頂部說明 -->
    <div class="top-area">
      <v-container class="px-sm-6 px-4 py-0">
        <v-row no-gutters>
          <v-col
            cols="12"
            lg="4"
            class="d-flex align-center justify-center justify-lg-start pt-10"
            :class="$vuetify.breakpoint.width < 425.02 ? 'pb-6 ' : 'pb-10 '"
          >
            <div :align="$vuetify.breakpoint.width > 1263 ? 'left' : 'center'">
              <div class="text-h4 font-weight-black mb-6">
                {{ bannerWord.title }}
              </div>
              <div class="text-sm-h6">
                {{ bannerWord.sub }}
              </div>
              <v-btn
                class="my-6 mr-4"
                color="primary"
                large
                style="background-color: white"
                outlined
                width="123"
                @click="GoVideo()"
                >教學說明</v-btn
              >
              <v-btn
                class="my-6"
                color="primary"
                width="123"
                large
                @click="ApplyAd()"
                >{{ applyAdBtn.name }}</v-btn
              >
            </div>
          </v-col>
          <v-col
            cols="12"
            lg="8"
            :class="$vuetify.breakpoint.width < 425.02 ? 'pb-10' : ''"
          >
            <div :align="$vuetify.breakpoint.width > 1263 ? 'right' : 'center'">
              <v-img :src="bannerImg" contain></v-img>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!-- #endregion -->
    <!-- #region 中間搜尋 -->
    <v-container class="px-sm-6 px-4 pb-3 pt-0">
      <div class="text-h6 font-weight-black pt-8 pb-3" align="left">
        {{ str.searchAds }}
      </div>
    </v-container>
    <v-container class="px-sm-6 px-4 pb-3 pt-0 search-block">
      <v-row>
        <v-col class="d-sm-flex">
          <!-- #region 搜尋框 -->
          <div style="width: 100%">
            <v-text-field
              @keyup.enter="$event.target.blur()"
              @blur="Search()"
              v-model="search"
              append-icon="mdi-magnify"
              :label="str.searchLabel"
              outlined
              clearable
              hide-details
              dense
            >
            </v-text-field>
          </div>
          <!-- #endregion -->
          <div style="padding: 6px"></div>
          <div class="d-flex">
            <!-- #region 廣告類型 -->
            <!-- #region 廣告類型-按鈕 -->
            <v-btn
              outlined
              height="40"
              color="grey darken-1"
              class="px-3"
              @click="CategoryDialogOpen()"
              ><v-icon class="d-none d-sm-flex">mdi-widgets</v-icon>
              <span class="text-body-2 ml-sm-2 mr-sm-4 mr-2">{{
                $vuetify.breakpoint.width > 340
                  ? categoryBtn.name
                  : categoryBtn.shortName
              }}</span>
              <v-badge
                v-if="categoryDialog.selectedList.length > 0"
                dot
                overlap
                offset-y="4"
                class="ml-1"
                color="red accent-2"
              ></v-badge>
              <v-icon>mdi-menu-down</v-icon>
            </v-btn>
            <!-- #endregion -->
            <!-- #region 廣告類型彈窗 -->
            <Category
              :open="categoryDialog.show"
              v-on:close="CategoryDialogClose"
              v-on:list="CategoryResultList"
              v-on:formatList="CategoryResultFormatList"
            />
            <!-- #endregion -->
            <!-- #endregion -->
            <div style="padding: 6px"></div>
            <!-- #region 進階篩選 -->
            <!-- #region 進階篩選-按鈕 -->
            <v-btn
              outlined
              height="40"
              color="grey darken-1"
              class="px-3"
              @click="OpenFilterDialog()"
              ><v-icon class="d-none d-sm-flex">mdi-tune</v-icon>
              <span class="text-body-2 ml-sm-2 mr-sm-4 mr-2">{{
                $vuetify.breakpoint.width > 900
                  ? filterBtn.name
                  : filterBtn.shortName
              }}</span>
              <v-badge
                v-if="
                  filterDialog.area.selected.length > 0 ||
                  filterDialog.industry.selected.length > 0
                "
                dot
                overlap
                offset-y="4"
                class="ml-1"
                color="red accent-2"
              ></v-badge>
              <v-icon>mdi-menu-down</v-icon>
            </v-btn>
            <!-- #endregion -->
            <!-- #region 進階篩選-彈窗 -->
            <v-dialog
              v-model="filterDialog.show"
              scrollable
              width="500px"
              @click:outside="CloseFilterDialog()"
            >
              <v-card>
                <!-- header -->
                <v-card-title class="px-4 font-weight-black">
                  <div>
                    {{ filterDialog.title }}
                  </div>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="CloseFilterDialog()">
                    <v-icon>mdi-close</v-icon></v-btn
                  >
                </v-card-title>
                <!-- body -->
                <v-card-text style="height: 304px" class="pa-0">
                  <!-- #region 搜尋框 (同步外部搜尋框) -->
                  <div class="px-4 pb-6 pt-3">
                    <v-text-field
                      @keyup.enter="$event.target.blur()"
                      v-model="search"
                      append-icon="mdi-magnify"
                      :label="str.searchLabel"
                      outlined
                      clearable
                      hide-details
                      dense
                    >
                    </v-text-field>
                  </div>
                  <v-divider></v-divider>
                  <!-- #endregion -->
                  <!-- #region 廣告地區-->
                  <div class="text-body-1 px-4 pt-4">
                    <div class="d-flex align-center py-2">
                      <div class="black--text">
                        {{ filterDialog.area.title }}
                      </div>
                      <v-spacer></v-spacer>
                      <v-btn
                        v-if="areaDialog.selectedList.length > 0"
                        small
                        @click="AreaDialogClear()"
                        >{{ filterDialog.area.clearBtn.name }}</v-btn
                      >
                    </div>
                    <div
                      class="d-flex align-center py-2"
                      style="cursor: pointer"
                      @click="AreaDialogOpen()"
                    >
                      <div v-if="areaDialog.selectedList.length < 1">
                        {{ filterDialog.area.empty }}
                      </div>
                      <div
                        v-else
                        class="d-inline-block black--text text-truncate"
                      >
                        {{ areaSelectedFormat }}
                      </div>
                      <v-spacer></v-spacer>
                      <v-btn icon @click="AreaDialogOpen()"
                        ><v-icon>mdi-chevron-right</v-icon></v-btn
                      >
                    </div>
                  </div>
                  <!-- #endregion -->
                  <v-divider></v-divider>
                  <!-- #region 公司行業類別-->
                  <div class="text-body-1 px-4 pt-4">
                    <div class="d-flex align-center py-2">
                      <div class="black--text">
                        {{ filterDialog.industry.title }}
                      </div>
                      <v-spacer></v-spacer>
                      <v-btn
                        v-if="industryDialog.selectedList.length > 0"
                        small
                        @click="IndustryDialogClear()"
                        >{{ filterDialog.industry.clearBtn.name }}</v-btn
                      >
                    </div>
                    <div
                      class="d-flex align-center py-2"
                      style="cursor: pointer"
                      @click="IndustryDialogOpen()"
                    >
                      <div v-if="industryDialog.selectedList.length < 1">
                        {{ filterDialog.area.empty }}
                      </div>
                      <div
                        v-else
                        class="d-inline-block black--text text-truncate"
                      >
                        {{ industrySelectedFormat }}
                      </div>
                      <v-spacer></v-spacer>
                      <v-btn icon @click="IndustryDialogOpen()"
                        ><v-icon>mdi-chevron-right</v-icon></v-btn
                      >
                    </div>
                  </div>
                  <!-- #endregion -->
                </v-card-text>
                <v-divider></v-divider>
                <!-- footer -->
                <v-card-actions class="py-4">
                  <v-spacer></v-spacer>
                  <v-btn color="" text @click="CloseFilterDialog()">
                    {{ filterDialog.cancel }}
                  </v-btn>
                  <v-btn color="primary" @click="ConfirmedFilterSelected()">
                    {{ filterDialog.confirm }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <!-- #endregion -->
            <!-- #endregion -->
            <!-- #region 進階篩選-廣告地區-彈窗 -->
            <Area
              :open="areaDialog.show"
              :clear="areaDialog.clear"
              :originList="areaDialog.selectedList"
              :searchMod="true"
              v-on:close="AreaDialogClose"
              v-on:list="AreaResultList"
              v-on:formatList="AreaResultFormatList"
            />
            <!-- #endregion -->
            <!-- #region 進階篩選-公司行業別-彈窗 -->
            <Industry
              :open="industryDialog.show"
              :clear="industryDialog.clear"
              :originList="industryDialog.originList"
              v-on:close="IndustryDialogClose"
              v-on:list="IndustryResultList"
              v-on:formatList="IndustryResultFormatList"
            />
            <!-- #endregion -->
            <div style="padding: 6px"></div>
            <!-- #region 排序 -->
            <v-select
              :value="orderSelecter.selected"
              v-model="orderSelecter.selected"
              @change="Search()"
              :items="orderSelecter.item"
              :item-text="
                $vuetify.breakpoint.width > 700 ? 'name' : 'shortName'
              "
              :item-value="'value'"
              class="text-body-2"
              :prepend-inner-icon="
                $vuetify.breakpoint.width > 600 ? 'mdi-swap-vertical' : ''
              "
              :style="[
                $vuetify.breakpoint.width > 600
                  ? { minWidth: '160px' }
                  : { minWidth: '' },
              ]"
              suffix
              outlined
              hide-details
              dense
            >
            </v-select>
            <!-- #endregion -->
          </div>
        </v-col>
      </v-row>
    </v-container>
    <!-- #endregion -->
    <!-- #region 資料渲染 -->
    <v-container class="px-sm-6 px-4 my-8">
      <v-row>
        <!-- #region 無資料 -->
        <v-col v-if="notFound" cols="12">
          <div align="center" class="my-16">
            <v-img
              :src="empty.img"
              contain
              max-height="160"
              max-width="190"
              class="mb-4"
            ></v-img>
            <div class="mb-1 text-h6 font-weight-black">{{ empty.title }}</div>
            <div class="mb-16 text--secondary">{{ empty.sub }}</div>
          </div>
        </v-col>
        <!-- #endregion -->

        <!-- #region 有資料 -->
        <template v-if="!notFound">
          <v-col cols="12" md="6" v-for="x in datas" :key="x.applyId">
            <a :href="x.url" target="_blank">
              <v-img
                :src="$vuetify.breakpoint.width > 600 ? x.md : x.sm"
                width="100%"
                height="100%"
                max-height="90"
              />
            </a>
          </v-col>
        </template>
        <!-- #endregion -->

        <!-- #region 骨架屏 -->
        <template v-if="moreBtn.loading">
          <v-col cols="12" md="6" v-for="x in 12" :key="x.id">
            <div>
              <v-skeleton-loader
                class="mr-2"
                type="image"
                width="100%"
                height="100%"
                max-height="90"
              ></v-skeleton-loader>
            </div>
          </v-col>
        </template>
        <!-- #endregion -->
      </v-row>
      <!-- #region 載入更多按鈕 -->
      <v-row v-if="datas.length > 1">
        <v-col cols="12" class="mt-10 mb-16">
          <v-btn
            v-if="more"
            color="primary"
            :loading="moreBtn.loading"
            @click="LoadMoreAds()"
          >
            {{ moreBtn.name }}
          </v-btn>
          <div
            v-if="!more && !notFound"
            style="color: rgba(0, 0, 0, 0.38)"
            class="font-weight-black text-h5"
          >
            {{ noMore }}
          </div>
        </v-col>
      </v-row>
      <!-- #endregion -->
    </v-container>
    <!-- #endregion  -->
    <Footer />
  </div>
</template>

<script>
import { Advertise_Search } from "@/apis/api.js";

import Header from "../../components/Common/Header.vue";
import Footer from "../../components/Common/Footer.vue";
import Industry from "../../components/Ad/Industry.vue";
import Category from "../../components/Ad/Category.vue";
import Area from "../../components/Ad/Area.vue";

export default {
  components: {
    Header,
    Footer,
    Industry,
    Category,
    Area,
  },
  metaInfo() {
    return {
      title: "小芋頭廣告",
      meta: [
        {
          name: "description",
          content: "開拓更多客群，讓您的廣告被更多人看見",
        },
        {
          property: "og:title",
          content: "小芋頭廣告",
        },
        {
          property: "og:description",
          content: "開拓更多客群，讓您的廣告被更多人看見",
        },
        {
          property: "og:image",
          content: require("@/assets/image/ads/AdsBanner.jpg"),
        },
      ],
    };
  },
  data() {
    return {
      bannerImg: require("@/assets/image/ads/AdsBanner.jpg"),
      bannerWord: {
        title: "小芋頭廣告",
        sub: "開拓更多客群，讓您的廣告被更多人看見",
      },
      applyAdBtn: {
        name: "立即申請廣告",
        disabled: false,
        loading: false,
      },
      str: {
        searchAds: "主動尋找廣告",
        searchLabel: "搜尋公司名稱",
      },
      categoryBtn: {
        name: "廣告類型",
        shortName: "類型",
        disabled: false,
        loading: false,
      },
      filterBtn: {
        name: "進階篩選",
        shortName: "篩選",
        disabled: false,
        loading: false,
      },
      orderSelecter: {
        name: "依地區搜尋",
        selected: null,
        item: [
          { name: "排序依最新", shortName: "最新", value: "descending" },
          { name: "排序依最舊", shortName: "最舊", value: "ascending" },
          //   {
          //     name: "排序依最多點擊",
          //     shortName: "點擊",
          //     value: "clickTimes",
          //   },
        ],
      },
      moreBtn: {
        name: "載入更多",
        disabled: false,
        loading: false,
      },

      empty: {
        img: require("@/assets/image/ads/Empty.svg"),
        title: "未找到結果",
        sub: "請重新輸入其他的關鍵字",
      },
      categoryDialog: {
        show: false,
        selectedList: [],
        selectedFormatList: [],
      },
      filterDialog: {
        show: false,
        title: "進階篩選廣告",
        cancel: "關閉",
        confirm: "確定",
        area: {
          title: "廣告地區",
          empty: "請選擇",
          clearBtn: {
            name: "清除",
            disabled: false,
            loading: false,
          },
          selected: [],
          formatSelected: [],
        },
        industry: {
          title: "公司行業類別",
          empty: "請選擇",
          clearBtn: {
            name: "清除",
            disabled: false,
            loading: false,
          },
          selected: [],
          formatSelected: [],
        },
        statistics: {},
      },
      areaDialog: {
        show: false,
        clear: false,
        selectedList: [],
        selectedFormatList: [],
      },
      industryDialog: {
        show: false,
        clear: false,
        selectedList: [],
        selectedFormatList: [],
        originList: [],
      },
      industrySlicedDatas: [],
      tab: 0,
      totalIndustraySearched: 0,
      totalIndustrayFlag: false,

      search: "",
      selected: "",
      datas: [],
      onceNum: 24,
      more: false,
      notFound: false,
      noMore: "暫無更多廣告~",
    };
  },
  beforeRouteUpdate(to, from, next) {
    this.$meta().refresh();
    next();
  },
  created() {
    this.$meta().refresh();
  },
  mounted() {
    this.$meta().refresh();
    this.orderSelecter.selected = this.orderSelecter.item[0].value;
    this.Search();
  },
  watch: {
    "industryDialog.selectedList"() {},
  },
  methods: {
    //#region  *** 廣告類型彈窗 functions
    // 開啟彈窗
    CategoryDialogOpen() {
      this.categoryDialog.show = true;
    },
    // 關閉彈窗
    CategoryDialogClose(data) {
      if (data) this.categoryDialog.show = false;
    },
    // 已選類型型List
    CategoryResultList(data) {
      this.categoryDialog.selectedList = data;
      this.categoryDialog.show = false;
      this.Search();
    },
    // 已選類型FormatList
    CategoryResultFormatList(data) {
      this.categoryDialog.selectedFormatList = data;
    },
    //#endregion

    //#region *** 進階篩選 functions

    //#region 開啟進階篩選廣告彈窗
    OpenFilterDialog() {
      this.areaDialog.selectedList = this.filterDialog.area.selected;
      this.areaDialog.selectedFormatList =
        this.filterDialog.area.formatSelected;

      this.filterDialog.industry.selected.forEach((x) => {
        this.industryDialog.selectedList.push(x);
      });

      this.filterDialog.industry.formatSelected.forEach((x) => {
        this.industryDialog.selectedFormatList.push(x);
      });

      this.filterDialog.show = true;
    },
    //#endregion

    //#region 關閉進階篩選廣告彈窗
    CloseFilterDialog() {
      this.AreaDialogClear();
      this.IndustryDialogClear();
      this.areaDialog.selectedList = [];
      this.industryDialog.selectedList = [];
      this.filterDialog.show = false;
    },
    //#endregion

    //#region 確認進階篩選廣告彈窗
    ConfirmedFilterSelected() {
      this.filterDialog.area.selected = this.areaDialog.selectedList;
      this.filterDialog.area.formatSelected =
        this.areaDialog.selectedFormatList;

      this.filterDialog.industry.selected = this.industryDialog.selectedList;
      this.filterDialog.industry.formatSelected =
        this.industryDialog.selectedFormatList;

      // 延遲顯示 為配合過場動畫
      setTimeout(() => {
        this.areaDialog.selectedList = [];
        this.industryDialog.selectedList = [];
      }, 300);

      this.filterDialog.show = false;
      this.Search();
    },
    //#endregion

    //#endregion

    //#region *** 廣告地區 functions
    // 開啟彈窗
    AreaDialogOpen() {
      this.areaDialog.show = true;
    },
    // 關閉彈窗
    AreaDialogClose(data) {
      if (data) this.areaDialog.show = false;
    },
    // 已選地區List
    AreaResultList(data) {
      this.areaDialog.selectedList = data;
      this.areaDialog.show = false;
    },
    // 已選地區FormatList
    AreaResultFormatList(data) {
      this.areaDialog.selectedFormatList = data;
    },
    // 清除已選地區別
    AreaDialogClear() {
      this.areaDialog.selectedList = [];
      this.areaDialog.selectedFormatList = [];
      this.areaDialog.clear = true;
    },
    //#endregion

    //#region  *** 公司行業別彈窗 functions
    // 開啟彈窗
    IndustryDialogOpen() {
      this.industryDialog.show = true;

      // address refrences = =
      this.industryDialog.originList = [];
      this.industryDialog.selectedList.forEach((x) => {
        this.industryDialog.originList.push(x);
      });
    },
    // 關閉彈窗
    IndustryDialogClose(data) {
      if (data) this.industryDialog.show = false;
    },
    // 已選行業別List
    IndustryResultList(data) {
      this.industryDialog.selectedList = data;
      this.industryDialog.show = false;
    },
    // 已選行業別FormatList
    IndustryResultFormatList(data) {
      this.industryDialog.selectedFormatList = data;
    },
    // 清除已選行業別
    IndustryDialogClear() {
      this.industryDialog.selectedList = [];
      this.industryDialog.selectedFormatList = [];
      this.industryDialog.clear = true;
    },
    //#endregion

    //#region  搜尋
    Search() {
      let data = {
        gotAmount: 0,
        onceNum: this.onceNum,
        searchString: this.search,
        sort: this.orderSelecter.selected,
        categoryId: this.categoryDialog.selectedList,
        // areaId: this.filterDialog.area.selected,
        distId: this.filterDialog.area.selected.map((x) => x.id),
        instudryCodes: this.filterDialog.industry.selected,
      };

      this.datas = [];
      this.notFound = false;
      this.Advertise_SearchApi(data);
    },
    //#endregion

    //#region 載入更多廣告
    LoadMoreAds() {
      let data = {
        gotAmount: this.datas.length,
        onceNum: this.onceNum,
        searchString: this.search,
        sort: this.orderSelecter.selected,
        categoryId: this.categoryDialog.selectedList,
        // areaId: this.filterDialog.area.selected,
        distId: this.filterDialog.area.selected.map((x) => x.id),
        instudryCodes: this.filterDialog.industry.selected,
      };

      this.Advertise_SearchApi(data);
    },
    //#endregion

    //#region 搜尋API
    Advertise_SearchApi(data) {
      this.moreBtn.loading = true;
      setTimeout(() => {
        Advertise_Search(data)
          .then((res) => {
            let tempData = res.data.data.list;
            this.more = res.data.data.hasMore;
            this.notFound = false;

            if (this.datas.length > 0) this.datas = this.datas.concat(tempData);
            else this.datas = tempData;
          })
          .catch((err) => {
            console.log(err.response.data.massage);
            this.datas = [];
            this.notFound = true;
            this.more = false;
          })
          .finally(() => {
            this.moreBtn.loading = false;
          });
      }, 500);
    },
    //#endregion

    //#region 申請廣告
    ApplyAd() {
      if (process.env.NODE_ENV === "production") {
        let newWindow = window.open();
        newWindow.location.href = "https://kingfong9595.blog/tarosms-ads/";
      } else {
        const url = this.$router.resolve({ name: "AdsApply" });
        window.open(url.href, "_blank");
      }
    },
    //#endregion

    GoVideo() {
      let newWindow = window.open();
      newWindow.location.href = "https://youtu.be/gZN1BK7obxY";
    },
  },
  computed: {
    //#region 地區顯示樣式
    areaSelectedFormat() {
      return this.areaDialog.selectedFormatList.join("、");
    },
    //#endregion

    //#region 公司行業類別樣式
    industrySelectedFormat() {
      return this.industryDialog.selectedFormatList.join("、");
    },
    //#endregion
  },
};
</script>

<style scoped>
.top-area {
  height: 100%;
  background: #e3f2fd;
}

.search-block {
  position: sticky;
  position: -webkit-sticky; /* for Safari */
  top: -2px;
  z-index: 90;
  background-color: white;
}
</style>
